(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-custom-code"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('casamonte-catalog')) {
    customElements.define('casamonte-catalog', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        if (!this.details || this.onCatalogToggle) return;
        this.onCatalogToggle = () => {
          if (!this.details.open || this.dataset.loaded === 'true') return;
          const template = this.querySelector('[data-catalog-template]');
          const viewer = this.querySelector('[data-catalog-viewer]');
          if (!template || !viewer) return;
          const content = document.importNode(template.content, true);
          content.querySelectorAll('iframe').forEach((frame) => {
            if (!frame.title) frame.title = this.dataset.catalogTitle || 'Collection catalog';
            frame.loading = 'eager';
          });
          viewer.append(content);
          this.dataset.loaded = 'true';
          template.remove();
        };
        this.details.addEventListener('toggle', this.onCatalogToggle);
        this.onCatalogToggle();
      }
      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.onCatalogToggle);
        this.onCatalogToggle = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
